import { Field, useFormikContext } from "formik";
import { FC, useCallback } from "react";

import __ from "web/Layout/Translations";

import CloseIcon from "web/assets/icons/close.svg";
import Magnifier from "web/assets/icons/magnifier.svg";

import classes from "./searchField.scss";

interface ISearchAutocompleteSearchFieldMobileProps {
  name: string;
  currentValue: string;
}

const SearchAutocompleteSearchFieldMobile: FC<
  ISearchAutocompleteSearchFieldMobileProps
> = ({ name, currentValue }) => {
  const { setFieldValue } = useFormikContext();
  const clearHandler = useCallback(() => {
    setFieldValue(name, "");
  }, [setFieldValue, name]);
  const clearClassName = currentValue ? classes.clear : classes.clearHidden;
  return (
    <div className={classes.root}>
      <button
        className={classes.submit}
        type="submit"
        data-t1="search_submit"
        aria-label="Search"
      >
        <Magnifier width={26} />
      </button>
      <Field
        className={classes.input}
        type="text"
        name={name}
        placeholder={__("Czego szukasz?")}
        autoComplete="off"
        data-t1="search_input"
        autoFocus
      />
      <button
        className={clearClassName}
        type="button"
        onClick={clearHandler}
        data-t1="search_clear"
        aria-label="Clear search input"
      >
        <CloseIcon width={18} />
      </button>
    </div>
  );
};

export default SearchAutocompleteSearchFieldMobile;
